import type { FaireProductEntity } from "../../entity_types/product";

export const p_cgt3wp3dvx: FaireProductEntity = {
  token: "p_cgt3wp3dvx",
  type: "product",
  name: "Hot and Flashy Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/4bc5b1c3b3e7c1152ca4dc14248fe361ae094120952e8935f91ce94359c06c2c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9bbfceaa69d206108c8f8f01bc259555b9af87d9a6c9809995ae40ca2fc30ae4.jpeg",
    "https://cdn.faire.com/fastly/f2e601f42934b39dca39a9a7cd812e06500ee5de91018c401bd73dcd8ab7b3b6.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/bf02e5f6160792208d31735a9c9ae9a9f0cc28878ce26c1d259eaeaeffd1ff35.jpeg",
    "https://cdn.faire.com/fastly/c3f234b153ba4768db23eb6e2bdca73fdf138cbdd5a3323f35a4067966066c4c.jpeg"
  ],
  priceDollars: 6.75,
  description: "We're movin'... we're groovin'... we're sweatin'... ohp, we're dizzy. Take a minute for yourself and get comfy in these Hot 'n Flashy socks.\n\nPerfect Mother’s Day gift!\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:56.637Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
